module.exports = __webpack_public_path__ + "img/dashboard-icon6.1dee94b2.svg";